import { createTranslations } from '@npco/utils-translations'

export const cardEmptyViewMessageTranslations = createTranslations({
  title: "You haven't been issued a Card yet",
  description: 'If you require a card, request an Admin to create one for you.',
})
